import AnimSection from "../AnimSection/AnimSection";
import "./HowItWorks.css";
import { NAV_LINKS } from "../../utils/constants";

export default function HowItWorksTemplate({ steps }) {
  return (
    <section id={NAV_LINKS[1].id} className="how-it-works">
      <div className="section">

        <AnimSection>
          <span className="section-label">Procesul nostru</span>
          <h2 className="section-title">
            De la idee la automatizare<br />în 4 pași simpli
          </h2>
          <p className="how-it-works__subtitle">
            Fără contracte lungi de consultanță. Mergem direct la soluție.
          </p>
        </AnimSection>

        <div className="how-it-works__grid">
          {steps.map((step, i) => (
            <AnimSection key={i} delay={i * 100}>
              <div className={`how-it-works__card ${i % 2 !== 0 ? "how-it-works__card--alt" : ""}`}>
                <span className="how-it-works__num">{step.num}</span>
                <h3 className="how-it-works__card-title">{step.title}</h3>
                <p className="how-it-works__card-desc">{step.desc}</p>
              </div>
            </AnimSection>
          ))}
        </div>

      </div>
    </section>
  );
}
